module.exports = __webpack_public_path__ + "a540f4b6abd823f8746ef9178990a285.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/goggles-VR-s.png
// module id = 2453
// module chunks = 0